import React, { useState } from 'react';
import { I18n } from '@aws-amplify/core';
import { Row, Col, Divider, Skeleton } from 'antd';
import { DownOutlined, UpOutlined } from '@ant-design/icons';

import { NoENSTasks } from './NoENSTasks';
import { Title } from '@/components/Typography';
import { ScoreTable } from '../components/ScoreTable';
import type { BeraResultCycleSummary } from '@/types/Bera';

interface ResultENSProps {
	isLoading?: boolean;
	cycleSummary: BeraResultCycleSummary;
	ens: boolean;
	bera_job_summary_id: string;
}

export function ResultENS({
	isLoading = false,
	cycleSummary,
	ens = false,
	bera_job_summary_id
}: Readonly<ResultENSProps>): JSX.Element {
	const [isOpen, setIsOpen] = useState<boolean>(false);

	if (isLoading) {
		return <Skeleton active />;
	}

	return (
		<React.Fragment>
			<Row justify="center" onClick={() => setIsOpen(!isOpen)} style={{ cursor: 'pointer', marginTop: '2rem' }}>
				<Col span={22}>
					<Row>
						<Title level={5}>{I18n.get('ENS Result')}</Title>
					</Row>
				</Col>
				<Col span={2} style={{ display: 'flex', justifyContent: 'end' }}>
					{isOpen ? <UpOutlined /> : <DownOutlined />}
				</Col>
			</Row>
			<Divider type="horizontal" />
			{isOpen && (
				<Row justify="center">
					<Col span={22}>
						<Row justify="start" style={{ marginBottom: '1rem' }}>
							<Title level={5}>{I18n.get('Cycle summary')}</Title>
						</Row>
						<Row justify="center">
							<ScoreTable cycleSummary={cycleSummary} isENS={true} ens={ens} />
						</Row>
					</Col>
					<NoENSTasks bera_job_summary_id={bera_job_summary_id} />
				</Row>
			)}
		</React.Fragment>
	);
}
